module.exports = __webpack_public_path__ + "img/p02@3x.bb2726b8.png";